import { getstg, setstg } from "./stg";
// Clear message stack in localStorage
export const clrmsg = () => {
    try {
        const stgItem = getstg();
        stgItem.messages = [];
        setstg(stgItem);
    }
    catch (err) {
        emergency();
    }
    ;
};
// Push message to message stack in localStorage
export const pushmsg = (msg) => {
    try {
        const stgItem = getstg();
        if (!stgItem.messages) {
            stgItem.messages = [msg];
        }
        else {
            stgItem.messages.push(msg);
        }
        setstg(stgItem);
    }
    catch (err) {
        emergency();
    }
    ;
};
// Pop message from message stack in localStorage
export const popmsg = () => {
    let msg = null;
    try {
        const stgItem = getstg();
        if (stgItem.messages) {
            msg = stgItem.messages.pop();
            setstg(stgItem);
        }
    }
    catch (err) {
        emergency();
    }
    ;
    return msg !== null && msg !== void 0 ? msg : null;
};
// Shit happened, nuke local storage object
const emergency = (err) => {
    if (err) {
        console.error(err);
    }
    console.error("Error reading, writing or parsing message stack.\n" +
        "Stack object is possibly corrupted and will be deleted.");
    clrmsg();
};
